import Sidebar from "./Sidebar"
import Canvas from "./Canvas"
// import AddItem from "../forms/AddItem"
import { BrowserContext } from "../contexts/BrowserContext"
import { useState } from "react"

const Browser = () => {

    const [browserContextData, setBrowserContextData] = useState({ 

        context : 'BrowserContext',
    
        sidebarSelections : [
            'Tiffins', 'Meals', 'Snacks', 'Desserts',
            'Indo-Chinese', 'South-Indian', 'North-Indian',
            'Biryanis', 'Curries', 'Soups', 'All Menu'
        ],
    
        sidebarSelected : '', 
    })

    return (
        <BrowserContext.Provider value={{browserContextData, setBrowserContextData}}>
            <div className='browser floatUp'>
                <Sidebar></Sidebar>
                <Canvas></Canvas>
            </div>
            {/* <AddItem></AddItem> */}
        </BrowserContext.Provider>
    )
}

export default Browser